import { Component, OnInit, OnDestroy } from '@angular/core';
import {UserService} from '../../../../user.service';
import {User} from '../../../../models/users.model';
import { Router, ActivatedRoute } from '@angular/router';
import {LabsService} from '../../../../labs.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-awsop-labs-def',
  templateUrl: './awsop-labs-def.component.html',
  styleUrls: ['./awsop-labs-def.component.css']
})
export class AwsopLabsDefComponent implements OnInit, OnDestroy {
  page = 0;
  user:User;
  subscription: Subscription;

  titleOptions = [
      'Intro',
      'Pre-requisites',
      'Create a Admin IAM Admin User.',
      'Create a Security Group for a web server.',
      'Create a web server using EC2.',
    'Create an EBS volume.',
    'Enable custom Cloudwatch alerting. ',
    'Create VPC with private and public subnets.',
    'Create EC2 admin user.',
    'Host a website in S3.',
    'Use AWS CLI to work with S3. ',
    'Use Cloudformation to deploy a web server.',
    'Create a load balancer between two web servers. ',
    'Create AutoScale Group for a web server.',
    'Create an image from a running web server. ',
    'Create a MYSQL RDS Instance.',
    'Clean Up.'
  ]

  aboutThisLabDescription = [


      'This courses covers the basics skills required for an AWS Operator and Solution Architect. <a href="#">video-link</a>.',

      '<ol><li>Create a free <a href="https://portal.aws.amazon.com/billing/signup#/start">AWS account</a></li><li>Review acloud.guru&#39;s System Arcitecht Associate <a href="https://acloud.guru/learn/aws-certified-solutions-architect-associate">course</a></li></ol>',

      'Create a Admin IAM User with full admin permissions. Login as that user for the rest of the lab.',

      'Create Security Group that allows SSH and HTTPS access.',

      'Create web server using EC2 Instance using the Amazon AMI 2 and install Apache with a hello world website. ' +
      'Access the site from the internet. Log into the the ec2 instance from your terminal using the generated ec2 SSH keys. ' +
      'Repeat this lab but create a bootstrap script to install apache, create the index.html file, and start apache without ' +
      'having to log into the box.  ',

      'Create an EBS volume of 10GB and attack it to your webserver. Take a snapshot of the volume. ',

      'Create a IAM role that gives your EC2 Web Server access to CloudWatch. Assign this role to your ' +
      'EC2 instance. Setup custom logging scripts to track disk usage on that ec2 instance. Verify the logs are in Cloudwatch. ',

      'Create a VPC with 2 subnets one private and one public. Launch EC2 instances in both. SSH from the public ' +
      'one to the private one. Set up the Network ACL and the Security groups to make this work. Set up a way to have' +
      ' the private subnet access the internet. ',

      'Create an IAM user that has full rights to just EC2 instances.',

      'Create an S3 bucket and host a index.html page on it. Access the index.html page from the internet. ',

      'Install Amazon AWS command line tools. Use the tools to store a file in S3 and then copy that file out of s3. ',

      'Setup a basic Cloudformation template to setup a basic web server running in ec2. Set up the proper permissions ' +
      'to get access to the webserver from the internet. Deploy the Cloudformation template.',

      'Create two AZs with one web server in each one. Put the web servers behind an ELB with round robin and access ' +
      'the index.html page from the internet. ',

      'Create an AutoScaling group for a web server behind an ELB with a minimum servers of Deploy it using ' +
      'your web server AMI with a bootstrap script to get the site up.',

      'Create an AMI from a running instance and copy it to another region to deploy a new web server. ',

      'Setup an RDS instance that supports Multi-AZ with automated backups. Have the instance be MySQL' +
      ' with the lowest settings . Create read replicas of the previous RDS instances.',

      'Tear down all lab instances and services that were created.'

  ]


  constructor(
      private userService: UserService,
      private router: Router,
      private lab_s: LabsService
      ) {

      this.subscription = this.lab_s.getLab().subscribe(num =>
          { this.page = num; });
   }

  ngOnInit() {
      this.page = this.lab_s.lab_number;
  }

   ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }


  setPage(num) {
    this.page = num;
  }

  gotoCoursesPage() {
    this.router.navigate(['/courses']);
  }

  next(){

    if (this.page > 2) {
        this.router.navigate([`/course/awsop/lab/${this.page - 2}`]);
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-labs-def/awsop-labs-def.component.ts